import apiAction from "../ajax/service"
import { getMonthRange } from "../helpers/helper"

import { setRangeAgreements, setRangeAvailability } from "../features/calendarSlice"

const loadProductAvailability = async (dispatch,month,productIds,availabilityData={})=>{
var {firstDay , lastDay} = getMonthRange(month,true)
  for (var pId in productIds){
        if (month in availabilityData){
            if (pId in availabilityData[month]){
                continue
            }
        }
        try{
        const availability = await apiAction('availability',{
            limit:50,
            filters:{
                select:{
                    date:true,
                    usedUnits:true
                },
                rentalId:pId,
                  AND : [
                { date__lte: lastDay },
                { date__gte: firstDay}
            ],
            }

        },'custom')
        dispatch(setRangeAvailability({data:availability,month:month,pId}))
        } catch(e){

    }
    }
}

const loadProductAgreements = async (dispatch ,month = "June 2025"  , productIds , agreementData = {}  ) =>{

    var {firstDay , lastDay} = getMonthRange(month,true)

    for (var pId in productIds){
        if (month in agreementData){
            if (pId in agreementData[month]){
                continue
            }
        }
        try{
        var agreements = await apiAction('agreements',
            {limit:30, filters : {      select : {
                startDate : true ,
                endDate : true ,
                rentalAgreement : {
                    select :{
                        tenant : {
                            select : {
                                email:true,
                                id:true
                            }
                        }
                    }
                } ,
                rental :{
                     select :{
                        name : true
                    }
                }
            },

            rentalId : pId,
            AND : [
                { startDate__lte: lastDay },
                { endDate__gte: firstDay}
            ],


        }}
        ,"custom")
        dispatch(setRangeAgreements({month ,  agreements:agreements , rentId:pId}))
    } catch(e){

    }
    }

}


export {loadProductAgreements,loadProductAvailability}
